import { useCallback, useContext, useEffect, useState } from "react";
import { authorOption, robotsOption, statusOption } from "../../../constant";
import { useService } from "../../../hooks";
import { NavigatorContext } from "../../../context";

export const useGarage = () => {
  const { navigateTo } = useContext(NavigatorContext);
  const { fetchByAttr } = useService("Data", "garage");
  const { setTitle } = useService("Meta");
  const { isEmpty } = useService("Misc");
  const { urlToSplitData, getLocationData } = useService("Router");
  const [, setactiveRobotsIndex] = useState<number>(0);
  const [, setactiveStatusIndex] = useState<number>(0);
  const [, setactiveAuthorIndex] = useState<number>(0);
  const [image, setimage] = useState<string>("[]");
  const [, setuid] = useState<string>("");
  const [title, settitle] = useState<string>("");
  const [slug, setslug] = useState<string>("");
  const [content, setcontent] = useState<string>("");
  const [, setexcerpt] = useState<string>("");
  const [, setcss] = useState<string>("");
  const [, setjs] = useState<string>("");
  const [, setcanonical] = useState<string>("");
  const [, setrobots] = useState<string>("");
  const [, setmetaDescription] = useState<string>("");
  const [, setmetaKeyword] = useState(null);
  const [, setauthor] = useState<string>("");
  const [publishDate, setpublishDate] = useState(new Date());
  const [, setstatus] = useState(null);
  const [category, setcategory] = useState([]);
  const [, settag] = useState(null);

  const urlData = urlToSplitData(getLocationData().pathname);
  const urlSlug = urlData[2];

  const getGarageData = useCallback(async (query) => {
    const result = await fetchByAttr(query);
    if (result.status) {
      if (result.data[0].status !== "publish") {
        navigateTo({ route: "/error404" });
      } else {
        const garageData = result.data[0];
        setactiveAuthorIndex(
          authorOption.findIndex((e) => e.value === garageData.robots)
        );
        setactiveRobotsIndex(
          robotsOption.findIndex((e) => e.value === garageData.robots)
        );
        setactiveStatusIndex(
          statusOption.findIndex((e) => e.value === garageData.status)
        );
        settag(isEmpty(garageData.tag) ? [] : JSON.parse(garageData.tag));
        setcategory(
          isEmpty(garageData.category) ? [] : JSON.parse(garageData.category)
        );
        setmetaKeyword(
          isEmpty(garageData.metaKeyword)
            ? []
            : JSON.parse(garageData.metaKeyword)
        );
        setTitle(garageData.title);
        settitle(garageData.title);
        setslug(garageData.slug);
        setcontent(garageData.content);
        setexcerpt(garageData.excerpt);
        setcss(garageData.css);
        setjs(garageData.js);
        setcanonical(garageData.canonical);
        setrobots(garageData.robots);
        setmetaDescription(garageData.metaDescription);
        setauthor(garageData.author);
        setpublishDate(new Date(garageData.publishDate));
        setstatus(garageData.status);
        setuid(garageData.uid);
        setimage(garageData.image);
      }
    }
  }, [fetchByAttr, isEmpty, navigateTo, setTitle]);

  useEffect(() => {
    if (slug !== urlSlug) getGarageData({ slug: urlSlug });
  }, [slug, urlSlug, getGarageData]);
  return {
    category: category.join(", "),
    title,
    publishDate,
    image,
    content,
    slug,
  };
};
